export default {
  studio_tech_hub_world_map: 'Studio Global Map',
  studio_tech_hub_matrix: 'Matrix',
  studio_capability_evaluation: 'Studio Capability Evaluation',
};
